import constans from './constans.js'
import store from '@/store/index.js'
let applicationId = {// 应用对应的id
}

applicationId[constans['COLUMN']] = 223,//栏目id
applicationId[constans['CONTENT']] = 224,//内容id
applicationId[constans['IMAGE']] =  232,//图片id
applicationId[constans['FILE']] =  233,//文件id
applicationId[constans['VIDEO']] =  264,//视频库id
applicationId[constans['BANNER']] =  231,//广告位id
applicationId[constans['INFORMAN']] =  269//信息管理id
applicationId[constans['REVIEW']] =  252//审批管理id
applicationId[constans['APP']] =  270//应用中心id
applicationId[constans['MAP']] = 260//地图id
applicationId[constans['JOB']] = 2//招聘id


let getAppId = (id) => {
  let menuObj = store.state.getApp.menuData
  let appId
  menuObj.length && menuObj.map(item => {
    if (item.id == id) {
      return appId = item.appId
    }
  })
  return appId
}

//根据父id获取子菜单
let getApps = (pId) => {
  let menuObj = store.state.getApp.menuData
  let targetApps = []
  menuObj.length && menuObj.map(item => {
    if (item.parentId == pId) {
      targetApps.push(item)
    }
  })
  return targetApps
}
//根据id获取appName
let getAppName = (id) => {
  let menuObj = store.state.getApp.menuData
  let appName
  menuObj.length && menuObj.map(item => {
    if(id ==10){
      return appName="意向信息"
    }
    if (item.appId == id) {
      return appName = item.name
    }
  })
  return appName
}
let getAppByUrl = (url) => {
  let menuObj = store.state.getApp.menuData
  let targetApp
  menuObj && menuObj.length && menuObj.map(item => {
    if (item.url == url) {
      return targetApp = item
    }
  })
  return targetApp
}
export { applicationId, getAppId, getApps, getAppName, getAppByUrl}



// WEBPACK FOOTER //
// ./src/assets/js/application.js